import { createParser } from "nuqs";

const parseAsIntegerEnum = <T extends number>(validValues: T[]) =>
  createParser({
    parse(queryValue) {
      const toNum = Number(queryValue) as T;
      if (validValues.includes(toNum)) {
        return toNum;
      }
    },
    serialize(value) {
      return value?.toString() ?? "";
    },
  });

const parseAsIntegerEnumArray = <T extends number>(validValues: T[]) =>
  createParser({
    parse(queryValue) {
      const values = queryValue
        .split(",")
        .map((value) => Number(value) as T)
        .filter((value) => validValues.includes(value));
      return values.length ? values : null;
    },
    serialize(value: T[]) {
      return value.join(",");
    },
  });

const parseAsInteger = createParser({
  parse(queryValue) {
    if (queryValue.length === 0) {
      return undefined;
    }
    const toNum = Number(queryValue);
    if (Number.isNaN(toNum)) {
      return undefined;
    }

    return toNum;
  },
  serialize(value) {
    return value?.toString() ?? "";
  },
});

const parseAsString = createParser({
  parse(queryValue) {
    const toString = String(queryValue);
    if (toString.length === 0) {
      return undefined;
    }

    return toString;
  },
  serialize(value) {
    return value?.toString() ?? "";
  },
});

const parseAsStringArray = createParser({
  parse(queryValue: string) {
    if (!queryValue) return null;
    const values = queryValue.split("|");
    return values.every((v) => typeof v === "string" && v.length > 0) ? values : null;
  },
  serialize(value: string[]) {
    return value.join("|");
  },
});

export const searchParamsParser = {
  parseAsIntegerEnum,
  parseAsIntegerEnumArray,
  parseAsInteger,
  parseAsString,
  parseAsStringArray,
};

export function enumNumbers<E extends object>(e: E): number[] {
  return Object.values(e).filter((v): v is number => typeof v === "number");
}

export function enumStrings<E extends object>(e: E): string[] {
  return Object.values(e).filter((v): v is string => typeof v === "string");
}

export function enumValues<E extends object>(e: E): (string | number)[] {
  return Object.values(e);
}
